import instance from '../axios';
var md5 = require('md5');
export const login = async (phone, password) => {
  const json = { phone: phone, password: md5(password) };
  const response = await instance.post('auth/login', json);
  return response.data;
};
